export const marketingArchetypes = [
  { key: "innocent", name: "The Innocent", description: "Pure, optimistic, simple" },
  { key: "explorer", name: "The Explorer", description: "Adventurous, curious, free-spirited" },
  { key: "sage", name: "The Sage", description: "Wise, knowledgeable, truthful" },
  { key: "hero", name: "The Hero", description: "Courageous, determined, inspiring" },
  { key: "outlaw", name: "The Outlaw", description: "Rebellious, provocative, disruptive" },
  { key: "magician", name: "The Magician", description: "Visionary, transformative, imaginative" },
  { key: "everyman", name: "The Everyman", description: "Relatable, grounded, authentic" },
  { key: "lover", name: "The Lover", description: "Passionate, intimate, emotive" },
  { key: "jester", name: "The Jester", description: "Humorous, playful, light-hearted" },
  { key: "caregiver", name: "The Caregiver", description: "Nurturing, protective, generous" },
  { key: "ruler", name: "The Ruler", description: "Authoritative, structured, dependable" },
  { key: "creator", name: "The Creator", description: "Innovative, artistic, expressive" },
] as const;

export type MarketingArchetypeKey = (typeof marketingArchetypes)[number]["key"];

export const marketingArchetypeImageMap: Record<MarketingArchetypeKey, string> = {
  innocent: "the-innocent-small.png",
  explorer: "the-explorer-small.png",
  sage: "the-sage-small.png",
  hero: "the-hero-small.png",
  outlaw: "the-outlaw-small.png",
  magician: "the-magician-small.png",
  everyman: "the-everyman-small.png",
  lover: "the-lover-small.png",
  jester: "the-jester-small.png",
  caregiver: "the-caregiver-small.png",
  ruler: "the-ruler-small.png",
  creator: "the-creator-small.png",
};
